import { useEffect } from 'react';

export default function MsClarity() {
  useEffect(() => {
    const projectId = import.meta.env.VITE_APP_CLARITY_PROJECT_ID;
    if (!projectId) return;
    if (document.getElementById('ms-clarity-script')) return;

    const script = document.createElement('script');
    script.id = 'ms-clarity-script';
    script.innerHTML = `
      (function(c,l,a,r,i,t,y){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
      })(window,document,"clarity","script","${projectId}");
    `;
    document.head.appendChild(script);

    return () => {
      script.remove();
    };
  }, []);

  return null;
}
